import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-xl mx-auto" }
const _hoisted_2 = { class: "text-center text-xl font-semibold" }
const _hoisted_3 = { class: "text-center text-muted-foreground mt-2" }
const _hoisted_4 = { class: "grid gap-1.5" }
const _hoisted_5 = { class: "grid gap-1.5" }

import { Head, useForm } from '@inertiajs/vue3';
    import { defineAsyncComponent, ref } from 'vue';
    import axios from 'axios';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { Button } from '@/components/ui/button';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import type { BreadcrumbItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserConnect',
  setup(__props) {

    const AppLayout = defineAsyncComponent(() => import('@/layouts/AppLayout.vue'));
    const PageCard = defineAsyncComponent(() => import('@/components/PageCard.vue'));
    const { t } = useI18n();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.outlay',
        },
    ];

    const form = useForm({
        email: '',
        password: '',
    });

    const isSubmitting = ref(false);
    function normalizeUrl(url: string): string {
        try {
            return /^[a-z][a-z0-9+.-]*:\/\//i.test(url) ? url : `${window.location.protocol}//${url}`;
        } catch (e) {
            return url;
        }
    }

    function redirectTo(url: string) {
        const target = normalizeUrl(url);
        try {
            window.location.href = target;
            return;
        } catch (e) {}

        try {
            window.location.assign(target);
            return;
        } catch (e) {}

        try {
            window.open(target, '_self');
        } catch (e) {}
    }

    const onSubmit = async () => {
        if (isSubmitting.value) return;
        isSubmitting.value = true;

        try {
            const { data } = await axios.post(route('outlay.user-connect.store'), {
                email: form.email,
                password: form.password,
            });

            if (data?.url) {
                redirectTo(data.url as string);
                return;
            }

            if (data?.redirect) {
                redirectTo(data.redirect as string);
                return;
            }

            if (data?.pjax_redirect) {
                redirectTo(data.pjax_redirect as string);
                return;
            }

            toast.error(t('forms.system_error'));
        } catch (error: any) {
            const errorMessage = error?.response?.data?.errors?.incorrect_credentials
                ?? error?.response?.data?.message
                ?? t('forms.system_error');
            toast.error(Array.isArray(errorMessage) ? errorMessage[0] : errorMessage);
        } finally {
            isSubmitting.value = false;
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('outlay.connect.title')
    }, null, 8, ["title"]),
    _createVNode(_unref(AppLayout), { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createVNode(_unref(PageCard), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('outlay.connect.title')), 1),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('outlay.connect.subtitle')), 1),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex justify-center mt-6 mb-8" }, [
                _createElementVNode("img", {
                  src: "/img/logo-outlay.svg",
                  alt: "Outlay",
                  class: "h-8"
                })
              ], -1)),
              _createElementVNode("form", {
                onSubmit: _withModifiers(onSubmit, ["prevent"]),
                class: "grid gap-4"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(Label), { for: "outlay_email" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('auth.email')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Input), {
                    id: "outlay_email",
                    modelValue: _unref(form).email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).email) = $event)),
                    type: "email",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(Label), { for: "outlay_password" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('auth.password')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Input), {
                    id: "outlay_password",
                    modelValue: _unref(form).password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).password) = $event)),
                    type: "password",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(_unref(Button), {
                  disabled: isSubmitting.value,
                  type: "submit",
                  width: "full",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('auth.login_txt')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 32)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})